import { render, staticRenderFns } from "./NotificationScreen.vue?vue&type=template&id=9362332e"
import script from "./NotificationScreen.vue?vue&type=script&lang=js"
export * from "./NotificationScreen.vue?vue&type=script&lang=js"
import style0 from "./NotificationScreen.vue?vue&type=style&index=0&id=9362332e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports